import React, { useState, useEffect } from "react";
import axios from "axios";
// import toastify
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import DatePicker from "react-datepicker";
// import  {detectOverflow }from "@popperjs/core";

const Vacancy = () => {
  const base_url = process.env.REACT_APP_BASE_URL;
  const [vacancies, setVacancies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const vacanciesPerPage = 10;
  const [itemsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState("desc");
  const [vacancy, setVacancy] = useState("");
  const [link, setLink] = useState("");
  const [expiryDate, setExpiryDate] = useState("");

  const [isVacancyPending, setIsVacancyPending] = useState(false);

  // pending states
  const [deletePending, setDeletePending] = useState(false);
  const [addPending, setAddPending] = useState(false);

  // Sort vacancies based on sortOrder
  const sortedVacancies = sortOrder === "asc" ? [...vacancies] : [...vacancies].reverse();

  // Logic for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedVacancies.slice(indexOfFirstItem, indexOfLastItem);
  // console.log(currentVacancies)
  //INTERCEPTOR
  // Create an instance of Axios
  const api = axios.create({
    baseURL: `${base_url}`,
  });

  // Set the authorization token for all requests
  api.interceptors.request.use((config) => {
    // Add your authorization token logic here
    const token = sessionStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  // HOOKS
  useEffect(() => {
    fetchData();
  }, []);

  //FUNCTIONS
  const fetchData = async () => {
    setIsVacancyPending(true);
    try {
      const response = await api.get(`${base_url}/vacancy/get-all-vacancy`);
      setVacancies(response.data.result);
      console.log(vacancies);
      setIsVacancyPending(false);
    } catch (error) {
      console.log(error);
    }
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const deleteSuccess = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const deleteError = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const handleDelete = (id) => {
    setDeletePending(true);
    api
      .post(`${base_url}/vacancy/${id}`)
      .then(function (response) {
        console.log(response.data);
        fetchData();
        setDeletePending(false);
        deleteSuccess("Vacancy record was successfully deleted");
        fetchData();
      })
      .catch(function (error) {
        console.log(error.response.data.message);
        deleteError("An error occurred while trying to delete vacancy");
      });
  };

  const toggleSortOrder = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
  };

  const addVacancySuccess = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 1800,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const addVacancyError = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 1800,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const handleSubmit = (event) => {
    event.preventDefault();
    setAddPending(true);
    const formattedDate = moment(expiryDate).format("YYYY-MM-DDTHH:mm");

    api
      .post(`${base_url}/vacancy/add-vacancy/`, {
        vacancy: vacancy,
        link: link,
        expiryDate: formattedDate,
      })
      .then(function (response) {
        console.log(response);
        setVacancy("");
        setLink("");
        addVacancySuccess("Vacancy Entry was successfully added");
        setAddPending(false);
        fetchData();
      })
      .catch(function (error) {
        console.log(error.response);
        addVacancyError(
          "An error occurred and vacancy wasnt added successfully"
        );
      });
  };

  // navigation options
  const nextPage = () => {
    if (currentPage < Math.ceil(sortedVacancies.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const firstPage = () => {
    setCurrentPage(1);
  };

  const lastPage = () => {
    setCurrentPage(Math.ceil(sortedVacancies.length / itemsPerPage));
  };

  const pageButtons = () => {
    const totalPages = Math.ceil(sortedVacancies.length / itemsPerPage);
    const buttons = [];

    // Display up to 3 page numbers ahead of the current page
    for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
      buttons.push(
        <button
          key={i}
          className={`btn-pagination ${currentPage === i ? "active-page" : ""}`}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>
      );
    }

    return buttons;
  };
  // end navigation options

  // JSX
  return (
    <>
      <div className="container-fluid">
        <ToastContainer />
        <div className="d-flex my-1">
          <div className="pt-3">
            <h6 className="section-title">
              <i className="bi bi-list"></i> VACANCIES
              <small
                className="text-secondary"
                style={{ fontWeight: "400", fontSize: "smaller" }}
              >
                {" "}
                ({vacancies.length})
              </small>
            </h6>
          </div>
          <div className="flex-fill text-end">
            <button
              className="btn-custom"
              data-bs-toggle="modal"
              data-bs-target="#add-vacancy"
            >
              <i className="bi bi-plus-circle"></i> Add
            </button>
            <button className="btn-custom ms-1" onClick={toggleSortOrder}>
              {sortOrder === "asc" ? (
                <div>
                  <i className="bi bi-sort-down"></i> Sort
                </div>
              ) : (
                <div>
                  <i className="bi bi-sort-up"></i> Sort
                </div>
              )}
            </button>
          </div>
        </div>
        <table className="table table-sm">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Vacancy</th>
              <th>Link</th>
              <th>Created on</th>
              <th>Expiring On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {isVacancyPending ? (
              <tr>
                <td colSpan="6" className="text-center">
                  <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                </td>
              </tr>
            ) : (
              currentItems.map((vacancy) => (
                <tr key={vacancy.id}>
                  <td>{vacancy.id}</td>
                  <td>{vacancy.vacancy}</td>
                  <td style={{ width: "300px" }}>{vacancy.link}</td>
                  <td>
                    {moment(vacancy.createdAt).format("DD MMM YYYY h:mm:ss a")}
                  </td>
                  <td>{moment(vacancy.expiryDate).format("DD MMM YYYY")}</td>
                  <td>
                    {deletePending ? (
                      <button className="btn-custom-sm disabled-btn" disabled>
                        <i className="bi bi-trash"></i>
                      </button>
                    ) : (
                      <button
                        className="btn-custom-sm"
                        onClick={() => handleDelete(vacancy.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Commented out by VM */}
        {/* <nav>
                    <ul className="pagination">
                        {Array.from({ length: Math.ceil(sortedVacancies.length / vacanciesPerPage) }, (_, index) => (
                            <li key={index}>
                                <button
                                    className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                                    onClick={() => paginate(index + 1)}
                                >
                                    {index + 1}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav> */}
        <div className="pagination btn-group">
          <button
            className="btn-pagination"
            onClick={firstPage}
            disabled={currentPage === 1}
          >
            First
          </button>

          <button
            className="btn-pagination"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            <i className="bi-chevron-left"></i>
          </button>

          {/* page numbered buttons */}
          {pageButtons()}

          <button
            className="btn-pagination"
            onClick={nextPage}
            disabled={
              currentPage === Math.ceil(sortedVacancies.length / itemsPerPage)
            }
          >
            <i className="bi-chevron-right"></i>
          </button>

          <button
            className="btn-pagination"
            onClick={lastPage}
            disabled={
              currentPage === Math.ceil(sortedVacancies.length / itemsPerPage)
            }
          >
            Last
          </button>
        </div>
      </div>

      <div className="modal fade" id="add-vacancy">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            {/* <!-- Modal Header --> */}
            <div className="modal-header">
              <h5 className="modal-title bold">
                <i className="bi bi-plus-circle"></i> Add Vacancy
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="modal-body">
              <div className="container-fluid">
                <form onSubmit={handleSubmit}>
                  <div className="input-group my-3">
                    <span class="input-group-text input-group-text-custom">
                      <i class="bi bi-pencil"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control custom-input-group"
                      value={vacancy}
                      onChange={(e) => setVacancy(e.target.value)}
                      placeholder="Vacancy"
                      required
                    />
                  </div>
                  <div className="input-group my-3">
                    <span class="input-group-text input-group-text-custom">
                      <i class="bi bi-link"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control custom-input-group"
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                      placeholder="Link"
                      required
                    />
                  </div>
                  <div className="input-group my-3">
                    <span className="input-group-text input-group-text-custom">
                      <i className="bi bi-calendar-x"></i>
                      <small className="bold ms-1 text-small">
                        {" "}
                        Expiry Date
                      </small>
                    </span>
                    <input
                      type="date"
                      className="form-control custom-input-group"
                      value={expiryDate}
                      onChange={(e) => setExpiryDate(e.target.value)}
                      placeholder="expiry Date"
                      required
                    />
                  </div>
                  {addPending ? (
                    <button
                      type="submit"
                      className="btn-custom w-100 disabled-btn"
                      disabled
                    >
                      <span class="spinner-border spinner-border-sm"></span>
                    </button>
                  ) : (
                    <button type="submit" className="btn-custom w-100">
                      Submit
                    </button>
                  )}
                </form>
              </div>
            </div>

            {/* <!-- Modal footer --> */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn-gray-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vacancy;
